<div class="edit-snapshot-modal-container">
  <!-- Header -->
  <div class="modal-header">
    <h2 class="modal-title">Edit Snapshot</h2>
    <button
      mat-icon-button
      class="close-button"
      (click)="onCancel()"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="modal-content">
    <!-- Snapshot Name Input -->
    <div class="form-section">
      <label class="input-label">Snapshot Name</label>
      <div class="input-container">
        <input
          #nameInput
          type="text"
          class="snapshot-input"
          [(ngModel)]="snapshotName"
          (input)="onNameInput()"
          placeholder="Enter snapshot name"
          maxlength="100"
          [disabled]="isSaving()"
        />
        <span class="char-hint">{{ remainingChars }} characters remaining</span>
      </div>
    </div>

    <!-- Description Section with Tabs -->
    <div class="description-section">
      <mat-tab-group
        class="description-tabs"
        [(selectedIndex)]="selectedTabIndex"
        (selectedIndexChange)="onTabChange($event)"
      >
        <!-- Edit Tab -->
        <mat-tab label="Edit">
          <div class="edit-tab-content">
            <textarea
              class="description-textarea"
              [(ngModel)]="description"
              (ngModelChange)="onDescriptionChange()"
              placeholder="Add a description or comment using Markdown..."
              rows="8"
              [disabled]="isSaving()"
            >
            </textarea>
          </div>
        </mat-tab>

        <!-- Preview Tab -->
        <mat-tab label="Preview">
          <div class="preview-tab-content">
            <div class="markdown-preview" [innerHTML]="renderedMarkdown()"></div>
            @if (!description.trim()) {
              <div class="no-preview">
                <mat-icon>visibility_off</mat-icon>
                <p>
                  No content to preview. Switch to the Edit tab to add a
                  description.
                </p>
              </div>
            }
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>

  <!-- Actions -->
  <div class="modal-actions">
    <button class="cancel-button" (click)="onCancel()" [disabled]="isSaving()">
      Cancel
    </button>
    <button
      class="save-button"
      (click)="onSaveSnapshot()"
      [disabled]="!isValid || isSaving() || !hasChanges"
    >
      {{ isSaving() ? "Saving..." : "Save" }}
    </button>
  </div>
</div>
